import React from 'react';
import { useDispatch } from 'react-redux';
import RefreshButton from 'shared/ui/RefreshButton';
import { getData } from 'store/Host/actions';
import { getHostsData } from 'store/HostsGeneral/actions';

const HostRefreshButton = ({ entity }) => {
  const dispatch = useDispatch();

  const handleClick = () => entity === 'assets' ? dispatch(getData()) : dispatch(getHostsData());

  return (
    <RefreshButton onClick={ handleClick } />
  );
};

export default HostRefreshButton;
